import axios from "axios";
const getBaseUrl = () => {
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  switch (true) {
    case currentUrl.includes("test"):
      return "https://testlumipaymentapi.phoneboxmobile.com/api/";
    default:
      return "https://lumipaymentapi.phoneboxmobile.com/api/";
  }
};
const instance = axios.create({
  baseURL: getBaseUrl(),
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const getPaymentTransaction = (paymentGuid) => {
  return instance.get(
    `/Payment/GetPaymentTransaction?PaymentTransactionGuid=${paymentGuid}`,
  );
};

export const cardLookUp = (paymentGuid, cardData) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    CreditCardNumber: cardData.CreditCardNumber,
    CreditCardName: cardData.CreditCardName,
    CCV: cardData.CCV,
    ExpirationMonth: cardData.ExpirationMonth,
    ExpirationYear: cardData.ExpirationYear,
    SaveCard: cardData.SaveCard,
  };

  return instance.post(`/Payment/CardLookup`, requestBody);
};

export const threeDSAuth = (orderId, amt) => {
  const encodedOrderId = encodeURIComponent(orderId);
  const encodedAmt = encodeURIComponent(amt);

  const userAgent = encodeURIComponent(
    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36",
  ).replace(/%20/g, "+");

  const threeDSData = `tci=U&ChallengeWindowSize=02&JavaEnabled=false&ScreenHeight=1080&ScreenWidth=1920&Language=en&UserAgent=${userAgent}`;

  return instance.post(
    `/pay_Moneris3DS/ThreeDSAuth?orderId=${encodedOrderId}&amt=${encodedAmt}`,
    threeDSData,
    {
      headers: {
        "Content-Type": "text/plain",
      },
    },
  );
};

export const postRawData = (cnum_oaid, amt, cardData, order_id, systag) => {
  const requestBody = {
    // systag: "alpha/postpaid",
    order_id: order_id,
    systag: systag,
    cnum_oaid: cnum_oaid,
    amount: amt,
    currency: "USD",
    crnum: cardData.CreditCardNumber,
    crexpyyyymm: `${cardData.ExpirationYear}${cardData.ExpirationMonth}`,
    cvv: cardData.CCV,
    isTest: false,
    crholder: cardData.CreditCardName,
  };

  return instance.post(`/pay_MonerisController/PostRawData`, requestBody);
};

export const processPayment = (paymentGuid, cardData) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    CreditCardNumber: cardData.CreditCardNumber,
    CreditCardName: cardData.CreditCardName,
    CCV: cardData.CCV,
    ExpirationMonth: cardData.ExpirationMonth,
    ExpirationYear: cardData.ExpirationYear.slice(-2),
    SaveCard: cardData.SaveCard,
    TurnstileToken: cardData.TurnstileToken || "",
  };

  return instance.post(`/Payment/ProcessPayment`, requestBody);
};

export const processOneTimePayment = (paymentGuid, cardData) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    CreditCardNumber: cardData.CreditCardNumber,
    CreditCardName: cardData.CreditCardName,
    CCV: cardData.CCV,
    ExpirationMonth: cardData.ExpirationMonth,
    ExpirationYear: cardData.ExpirationYear.slice(-2),
    SaveCard: cardData.SaveCard,
    TurnstileToken: cardData.TurnstileToken || "",
  };

  return instance.post(`/Payment/ProcessOneTimePayment`, requestBody);
};

export const recordGooglePayTransaction = (paymentGuid, monerisResponse) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    MonerisTransactionId: monerisResponse.receipt.TransID || "",
    MonerisResponseCode: monerisResponse.receipt.ResponseCode || "",
    MonerisMessage: monerisResponse.receipt.Message || "",
    Amount: parseFloat(monerisResponse.receipt.TransAmount || 0),
    MonerisReceiptId: monerisResponse.receipt.ReceiptId || "",
    MonerisReferenceNumber: monerisResponse.receipt.ReferenceNum || "",
    MonerisAuthCode: monerisResponse.receipt.AuthCode || "",
    SaveCard: false,
  };
  return instance.post(`/GooglePay/RecordGooglePayTransaction`, requestBody);
};

export const recordGooglePayOneTimeTransaction = (
  paymentGuid,
  monerisResponse,
) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    MonerisTransactionId: monerisResponse.receipt.TransID || "",
    MonerisResponseCode: monerisResponse.receipt.ResponseCode || "",
    MonerisMessage: monerisResponse.receipt.Message || "",
    Amount: parseFloat(monerisResponse.receipt.TransAmount || 0),
    MonerisReceiptId: monerisResponse.receipt.ReceiptId || "",
    MonerisReferenceNumber: monerisResponse.receipt.ReferenceNum || "",
    MonerisAuthCode: monerisResponse.receipt.AuthCode || "",
    SaveCard: false,
  };
  return instance.post(
    `/GooglePay/RecordGooglePayOneTimeTransaction`,
    requestBody,
  );
};

export const createApplePaySession = (paymentGuid) => {
  return instance.post(`/ApplePay/CreateApplePaySession`, {
    PaymentGuid: paymentGuid,
  });
};

export const recordApplePayTransaction = (paymentGuid, monerisResponse) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    MonerisTransactionId: monerisResponse.receipt.TransID || "",
    MonerisResponseCode: monerisResponse.receipt.ResponseCode || "",
    MonerisMessage: monerisResponse.receipt.Message || "",
    Amount: parseFloat(monerisResponse.receipt.TransAmount || 0),
    MonerisReceiptId: monerisResponse.receipt.ReceiptId || "",
    MonerisReferenceNumber: monerisResponse.receipt.ReferenceNum || "",
    MonerisAuthCode: monerisResponse.receipt.AuthCode || "",
    SaveCard: false,
  };
  return instance.post(`/ApplePay/RecordApplePayTransaction`, requestBody);
};

export const recordApplePayOneTimeTransaction = (
  paymentGuid,
  monerisResponse,
) => {
  const requestBody = {
    PaymentGuid: paymentGuid,
    MonerisTransactionId: monerisResponse.receipt.TransID || "",
    MonerisResponseCode: monerisResponse.receipt.ResponseCode || "",
    MonerisMessage: monerisResponse.receipt.Message || "",
    Amount: parseFloat(monerisResponse.receipt.TransAmount || 0),
    MonerisReceiptId: monerisResponse.receipt.ReceiptId || "",
    MonerisReferenceNumber: monerisResponse.receipt.ReferenceNum || "",
    MonerisAuthCode: monerisResponse.receipt.AuthCode || "",
    SaveCard: false,
  };
  return instance.post(
    `/ApplePay/RecordApplePayOneTimeTransaction`,
    requestBody,
  );
};

export default instance;
